import api from '../../../App/socket';

// is not used
export const getBikeVariants = (params) => (
    api.send({
        api: 'db',
        model: 'Bike_variant',
        action: 'Read',
        options: {
            attributes: 'all',
            limit: 1,
            where: {
                ref_bike_model: params.model_id,
                year: params.year,
                _id: params._id,
            },
            order: {
                name: 'asc',
            },
        },
    }).then((response) => response).catch((error) => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/requests/get_bike_variants_request.js